module.exports = __webpack_public_path__ + "img/ic_wutu@2x.49097218.png";